import React from 'react';
import PropTypes from 'prop-types';

import { Inline } from '@styleseat/ui';
import { HeaderText } from '../../../ui/HeaderText';

import { CITY_SERVICE_DATA, CITY_SERVICE_DATA2 } from './constants';
import { SEOAccordion } from './SEOAccordion';
import { useIsMobile } from '../../../../hooks';
import { Stack } from '../../../ui';

const SEOLinks = ({ onClick, utmParams }) => {
  const isMobile = useIsMobile();
  const LayoutComponent = isMobile ? Stack : Inline;
  return (
    <Stack
      paddingY={28}
      paddingX={isMobile ? 5 : 60}
      alignItems={isMobile ? 'stretch' : 'center'}
      space={10}
    >
      <Inline flexGrow={1} flexShrink={1} paddingX={8}>
        <HeaderText
          level="1"
          textAlign={isMobile ? 'left' : 'center'}
        >
          Browse popular hair services
        </HeaderText>
      </Inline>
      <LayoutComponent space={isMobile ? 0 : 40}>
        <SEOAccordion data={CITY_SERVICE_DATA} onClick={onClick} utmParams={utmParams} />
        <SEOAccordion data={CITY_SERVICE_DATA2} onClick={onClick} utmParams={utmParams} />
      </LayoutComponent>
    </Stack>
  );
};

SEOLinks.propTypes = {
  onClick: PropTypes.func.isRequired,
  utmParams: PropTypes.object.isRequired,
};

export default SEOLinks;
